<template>
    <div>
        <limitless-page-header></limitless-page-header>

        <div class="content">
            <b-card no-body>
                <b-card-header>
                    <b-button :style="{float: 'right'}" @click="showHiddenTypes">Visa {{ showHiddenStats ? 'aktiva' : 'inaktiva' }}</b-button>
                </b-card-header>
                <b-table
                    :items="filteredStats"
                    :fields="[
                        {
                            key: 'label',
                            label: 'Typ',
                        },
                        {
                            key: 'available',
                            label: 'Saldo',
                        },
                        {
                            key: 'limit',
                            label: 'Varningsnivå',
                        },
                        {
                            key: 'prognos',
                            label: 'Prognos kommande 2 veckor',
                        },
                        {
                            key: 'active',
                            label: 'Aktiverad',
                            formatter: function (value) {
                                return value ? 'Ja' : 'Nej';
                            },
                        },
                    ]"
                >
                </b-table>
            </b-card>
<!--            <accordion id="claim-codes" title="Registrera nya koder till kund">-->
<!--                <claim-codes/>-->
<!--            </accordion>-->
            <accordion id="product-codes" title="Importera digitalakoder">
                <section class="p-2">
                    <b-row>
                        <b-col cols="4">
                            <b-form-group label="Giltighetstid">
                                <v-date-picker
                                    mode="date"
                                    v-model="expires"
                                    :model-config="{ type: 'string', mask: 'iso', timezones: ['Europe/Stockholm'], timezone: 'Europe/Stockholm', locale: 'sv-SE' }"
                                ></v-date-picker>
                            </b-form-group>
                            <b-form-group label="Inställningar">
                                <b-checkbox v-model="override">Skriv över giltighetstid</b-checkbox>
                            </b-form-group>
                            <b-form-group label="Kodtyp">
                                <product-codes-types-filter v-model="type"></product-codes-types-filter>
                            </b-form-group>
                        </b-col>
                        <b-col cols="8">
                            <b-form-group label="Koder">
                                <b-textarea rows="16" v-model="codes"></b-textarea>
                            </b-form-group>
                            <b-alert variant="info" show>
                                Ange en kod per rad.<br>
                                Koderna kan anges enligt följande format:<br>
                                7898276462876<br>
                                7898276462876 - 2022-11-30<br>
                                7898276462876,2022-11-30<br>
                                7898276462876;2022-11-30<br>
                            </b-alert>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-card no-body>
                                <b-card-header>
                                    <b-button
                                        :style="{float: 'right'}"
                                        variant="success"
                                        @click="exportData"
                                    >
                                        Importera {{ codesCount }}st ({{ labelType }})
                                    </b-button>
                                </b-card-header>
                                <b-table
                                    :items="processed"
                                    :fields="[
                                    {
                                        key: 'code',
                                        label: 'Kod'
                                    },
                                    {
                                        key: 'expires',
                                        label: 'Giltighetstid',
                                        formatter: formatDate,
                                    },
                                    {
                                        key: 'type.label',
                                        label: 'Typ',
                                    }
                                ]"
                                ></b-table>
                            </b-card>
                        </b-col>
                    </b-row>
                </section>
            </accordion>
        </div>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import VDatePicker from 'v-calendar/lib/components/date-picker.umd';
import ProductCodesTypesFilter from '@components/Filters/ProductCodesTypesFilter';
import notify from '@services/Notify';
import Accordion from '@components/Accordion';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
// import ClaimCodes from './ClaimCodes';

export default {
    name: 'ProductCodes',
    components: {
        // ClaimCodes,
        Accordion,
        VDatePicker,
        ProductCodesTypesFilter,
        LimitlessPageHeader,
    },
    data() {
        return this.defaultData();
    },
    mounted() {
        this.getCodeStats();
    },
    computed: {
        processed() {
            return this.codes?.split(/\r?\n/).map((string) => {
                if (string.length > 0) {
                    return this.mapCode(string);
                }
                return null;
            }).filter((code) => code !== null);
        },
        codesCount() {
            return this.processed?.length || 0;
        },
        labelType() {
            return this.type?.label || 'Not found';
        },
        filteredStats() {
            return this.showHiddenStats ? this.stats : this.stats?.filter((item) => item.active);
        },
    },
    methods: {
        defaultData() {
            return {
                type: {
                    id: null,
                    label: 'Not set',
                },
                codes: null,
                expires: null,
                override: false,
                types: [],
                stats: [],
                showHiddenStats: false,
            };
        },
        mapCode(string) {
            const fields = string.replace(' - ', ';').replace(',', ';').split(';').map((str) => str.trim());

            let date = this.expires;
            if (!this.override && fields[1]) {
                if (fields[1].split('-').length >= 3 && (new Date(fields[1])).toDateString() !== 'Invalid Date') {
                    date = (new Date(fields[1])).toISOString();
                }
            }

            return {
                expires: date,
                code: fields[0],
                type: this.type,
            };
        },
        reset() {
            this.codes = this.defaultData().codes;
            this.type = this.defaultData().type;
        },
        exportData() {
            if (this.type.id === null) {
                notify('Välj kodtyp', 'Du måste sätta en kodtyp', 'error');
                return;
            }

            this.$bvModal.msgBoxConfirm(`Är du säker på att du vill importera ${this.codesCount}st till ${this.type.label}?`).then((result) => {
                if (result) {
                    apiClient.post('/vue/product/code/import', {
                        codes: this.processed,
                    }).then((res) => {
                        if (res.status >= 200 && res.status < 300) {
                            notify('Import klar', 'Ser ut som detta fungerade ganska ok?', 'success');
                            this.reset();
                        } else {
                            notify('Något gick snett...', 'Något oväntat hände', 'error');
                        }
                    });
                }
            });
        },
        formatDate(value) {
            return new Date(value).toISOString().split('T')[0];
        },
        getCodeStats() {
            apiClient.get('/vue/product/code/stats').then((res) => {
                this.stats = res.data.data;
            });
        },
        showHiddenTypes() {
            this.showHiddenStats = !this.showHiddenStats;
        },
    },
};
</script>
